<div class="user-menu-button"
     appMenuFocusHandler
     #focusHandler="menuFocusHandler">
  <button appMenuFocusParent
          class="header-menu-link header-button-box">
    <div class="profile-avatar" data-automation-id="bc-profile-avatar">
      <div class="profile-initial" *ngIf="isLoggedIn && initial; else personGenericTpl">{{ initial }}</div>
      <ng-template #personGenericTpl>
        <svg-icon icon="person-filled"></svg-icon>
      </ng-template>
    </div>
  </button>

  <div class="menu-hover menu-border" data-automation-id="bc-user-menu">
    <ul class="link-list">
      <li>
        <app-language-selector #languageSelector
                               appMenuFocusTarget
                               [focusTarget]="languageSelector"
                               [focusHandler]="focusHandler"
                               [isFocusable]="focusHandler.isFocusable">
        </app-language-selector>
      </li>

      <li *ngIf="isLoggedIn && isBoldEnabled">
        <app-accessibility-settings #a11ySettings
                                    appMenuFocusTarget
                                    [focusTarget]="a11ySettings"
                                    [focusHandler]="focusHandler"
                                    [isFocusable]="focusHandler.isFocusable">
        </app-accessibility-settings>
      </li>

      <li *ngIf="isLoggedIn">
        <button class="js-keyboard-shortcuts-menuitem link-item"
                data-automation-id="bc-select-settings"
                appMenuFocusTarget
                [focusHandler]="focusHandler"
                [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                (click)="selectSettings.emit()">{{ 'bcNavbar.settings' | translate }}</button>
      </li>

      <li *ngIf="isLoggedIn && isRecordingsEnabled">
        <button class="link-item"
                data-automation-id="bc-select-recordings"
                appMenuFocusTarget
                [focusHandler]="focusHandler"
                [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                (click)="selectRecordings.emit()">{{ ( isHybrid ? 'bcNavbar.dxRecordings' : 'bcNavbar.recordings' ) | translate }}</button>
      </li>

      <div class="navbar-line-separator"></div>

      <li>
        <button class="link-item"
                data-automation-id="bc-open-genesys-link"
                appMenuFocusTarget
                [focusHandler]="focusHandler"
                [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                (click)="openUrl.emit('https://www.genesys.com/genesys-dx')">
          {{ 'bcNavbar.genesysUrl' | translate }}
        </button>
      </li>

      <li *ngIf="isBoldEnabled">
        <button class="link-item"
                data-automation-id="bc-dashboard-link"
                appMenuFocusTarget
                [focusHandler]="focusHandler"
                [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                (click)="openUrl.emit('https://dashboard.boldchat.com')">
          {{ ( isHybrid ? 'bcNavbar.dxDashboard' : 'bcNavbar.dashboard' ) | translate }}
        </button>
      </li>

      <li *ngIf="isBoldEnabled">
        <button class="link-item"
                data-automation-id="bc-reports-link"
                appMenuFocusTarget
                [focusHandler]="focusHandler"
                [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                (click)="openUrl.emit('https://reports.boldchat.com')">
          {{ ( isHybrid ? 'bcNavbar.dxReports' : 'bcNavbar.reports' ) | translate }}
        </button>
      </li>

      <div class="navbar-line-separator"></div>

      <li>
        <button class="link-item"
                data-automation-id="bc-open-help-link"
                appMenuFocusTarget
                [focusHandler]="focusHandler"
                [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                (click)="openUrl.emit(helpLink)">{{ 'bcNavbar.help' | translate }}</button>
      </li>

      <div class="navbar-line-separator"></div>

      <ng-container *ngIf="isLoggedIn">
        <li *ngIf="canChangePassword">
          <button class="js-change-password-menuitem link-item"
                  data-automation-id="bc-select-change-password"
                  appMenuFocusTarget
                  [focusHandler]="focusHandler"
                  [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                  (click)="selectChangePassword.emit()">{{ 'bcNavbar.changePwd' | translate }}</button>
        </li>

        <li *ngIf="isUserWithMultipleAccount">
          <button class="link-item"
                  data-automation-id="bc-select-switch-account"
                  appMenuFocusTarget
                  [focusHandler]="focusHandler"
                  [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                  (click)="selectSwitchAccount.emit()">{{ 'bcNavbar.switchAccount' | translate }}</button>
        </li>

        <div class="navbar-line-separator"></div>
      </ng-container>

      <li class="inline-container" *ngIf="isLoggedIn">
        <div class="inline-label" *ngIf="username">{{ username }}</div>
        <div class="inline-label" *ngIf="!username">{{ 'bcNavbar.operatorName' | translate }}</div>
        <button class="inline-link"
                id="logoutButton"
                appMenuFocusTarget
                [focusHandler]="focusHandler"
                [tabindex]="focusHandler.isFocusable | appIsFocusableTabIndex"
                (click)="selectLogout.emit()">{{ 'bcNavbar.logout' | translate }}</button>
      </li>
    </ul>
  </div>
</div>
